import { useQuery } from '@tanstack/react-query';
import { getAppointmentCancellationDetailsById } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useAppointmentCancellationDetailsQuery = (appointmentId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'appointment', appointmentId, 'cancellationDetails' ],
    queryFn: async () => {
      const response = await getAppointmentCancellationDetailsById(appointmentId);

      return response.data;
    },
    ...opts,
  });
};
